import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { DatasetService } from 'src/app/services/dataset.service';

@Component({
  selector: 'app-view-datasets',
  templateUrl: './view-datasets.component.html',
  styleUrls: ['./view-datasets.component.scss']
})
export class ViewDatasetsComponent implements OnChanges, OnDestroy {
  @Input() datasetId: any;
  private unsubscribe$ = new Subject<void>();
  datasetData!: DataSetData["responseData"];
  dataetTable: string[][] = [];
  items: MenuItem[] = [];
  accountId: string = '';

  constructor(private datasetservice: DatasetService
  ) { }

  ngOnChanges(): void {
        if(this.datasetId){
          this.getDataSetById(this.datasetId);
        }
  }

  getDataSetById(datasetId: string) {
    this.datasetservice.getdatasetById(datasetId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result?.responseData) {
          this.datasetData = result.responseData;
          this.dataetTable = Object.entries(this.datasetData.sourceDataSet);
          this.accountId = this.datasetData.customerDetails.accountId;
          this.items = [
            { label: 'Account Details', routerLink: '/config/account/list' },
            { label: 'View Account Details', routerLink: `/config/account/${this.accountId}/view` },
            { label: 'View Dataset Details' }
          ];
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
